import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { isStaff } from '../../../common/typeAssertionFunctions';
import { Staff } from '../../../common/types';
import DarkUpperSection from '../../../components/section/DarkUpperSection';
import StyledSelect from '../../../components/select/StyledSelect';
import useAuthStore from '../../../datastore/useAuth';
import useStations from '../../../datastore/useStations';
import useAlert from '../../../hooks/useAlert';
import useLoadingModal from '../../../hooks/useLoadingModal';
import OnlineOrdering from './components/OnlineOrdering';
import LoyaltyPointsSettings from './components/LoyaltyPointsSettings';

export default function StaffSettings() {
  const { currentUser, updateStaffStation } = useAuthStore()

  const currentUserStationId = (currentUser as Staff)?.stationId ?? 0;
  const { stations = [], loading: stationsLoading } = useStations();
  const { loading, setLoading } = useLoadingModal()

  const theme = useTheme();
  const { showAlert } = useAlert();

  const selectedStation = (stations || []).find(f => f.id === currentUserStationId)

  async function saveStation(id: number) {
    const newStation = stations.find((s) => s.id === id);
    if (!id || !newStation) {
      showAlert('Please select a station', 'error');
      return;
    }
    if (!isStaff(currentUser)) {
      showAlert('You are not authorized to set a station', 'error');
      return
    }
    setLoading(true)
    try {
      await updateStaffStation(newStation)
    } catch (error) {
      showAlert('Update station failed', 'error');
      console.error(error);
    } finally {
      setLoading(false)
    }
  }

  if (!stations.length || !isStaff(currentUser)) return null;

  const orderedStations = [
    { value: 0, name: 'Choose Station', id: 0 },
    ...stations.sort((a, b) => a.name.localeCompare(b.name)),
  ];

  return (
    <Stack flex={1} sx={{ height: '100vh' }}>
      <DarkUpperSection>
        <Stack direction="row" spacing={4} sx={{ padding: '1em 0', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography
            variant="h2"
            fontWeight="bold"
            color={theme.palette.primary.contrastText}
            flex={1}
          >
            Settings
          </Typography>
        </Stack>
      </DarkUpperSection>
      <Stack flex={1} direction="column" marginX={2}>
        <Stack direction="row" spacing={4} sx={{ alignItems: 'center', paddingY: 2 }}>
          <Typography variant="h4">
            Set your Station:
          </Typography>
          <StyledSelect
            value={
              (selectedStation
                ? selectedStation.id
                : currentUser?.stationId) || 0
            }
            onChange={(e) => saveStation(e ? +e : 0)}
            disabled={loading || stationsLoading}
          >
            {orderedStations?.map((station) => (
              <MenuItem
                key={station.id}
                value={station.id}
                disabled={station.id === 0}
              >
                {station.name}
              </MenuItem>
            ))}
          </StyledSelect>

        </Stack>
        <OnlineOrdering />
        <LoyaltyPointsSettings />
      </Stack>
    </Stack>
  );
}
